
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkIssueBOMGrid extends Serenity.EntityGrid<JobWorkIssueBOMRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkIssueBOM'; }
        protected getDialogType() { return JobWorkIssueBOMDialog; }
        protected getIdProperty() { return JobWorkIssueBOMRow.idProperty; }
        protected getInsertPermission() { return JobWorkIssueBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkIssueBOMRow.localTextPrefix; }
        protected getService() { return JobWorkIssueBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}